import { Dialog, DialogTitle, DialogContent, /*DialogActions,*/ Button, Grid, TableHead, TableRow, TableCell, TableBody, Table } from "@material-ui/core"
import { BuscadorOferente } from "./BuscadorOferente"
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startAlerta } from "../../../actions/ui/alertas";
import { TraerOferentesPorCotizacion } from "../../../actions/compras/OferentesAction";
import { DeleteOutlineOutlined } from "@material-ui/icons";
import { desSeleccionaOferente, NuevoOferenteEnCotizacionCarga } from "../../../actions/compras/Cotizaciones";

export const ModalCargarOferente = (props) => {
    const dispatch = useDispatch();
    const { oferente, oferentesPorCotizacion } = useSelector((state) => state.compras)
    const [oferentes, setOferentes] = useState([]);
    let oferentesEliminar = [];

    useEffect(() => {
        if (oferente !== null) {
            var oferenteExistente = oferentesPorCotizacion.find(x => x.idOferente === oferente.idOferente);
            if (oferenteExistente === undefined) {
                setOferentes(oferentes => oferentes.concat(oferente))
            } else {
                dispatch(startAlerta('El oferente ya está cargado.', "warning", `¡Error!`))
            }
        }
    }, [dispatch, oferente])

    const eliminarOferente = (oferente) => {
        if (oferentes.indexOf(oferente) > -1) {
            if (oferentes.length > 1) {
                oferentesEliminar = oferentes.filter(x => x.idOferente !== oferente.idOferente)
                setOferentes(oferentesEliminar)
            } else {
                oferentesEliminar = oferentes.shift()
                setOferentes([])
            }
        }
    }

    const handleSave = () => {
        dispatch(NuevoOferenteEnCotizacionCarga(props.idCotizacion, oferentes,props.idEstado, props.idTipoSolicitud))
        setOferentes([]);
        dispatch(desSeleccionaOferente());
        dispatch(props.closeModalHandler);
    }

    useEffect(() => {
        dispatch(TraerOferentesPorCotizacion(props.idCotizacion))
    }, [dispatch, props.idCotizacion])

    return (
        <Dialog
            fullWidth
            maxWidth={'md'}
            open={props.open}>
            <DialogTitle style={{ textAlign: 'center' }}>Agregar Oferente a la  Orden N° {props.idSolicitud}</DialogTitle>
            <DialogContent>
                <BuscadorOferente />
                <Grid>
                    <Grid item xs={8} style={{ display: 'flex', margin: 'auto' }} >
                        {oferentes.length > 0 && (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nombre</TableCell>
                                        <TableCell>CUIT</TableCell>
                                        <TableCell>Mail</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {oferentes.map((item) => (
                                        <TableRow>
                                            <TableCell>{item.razonSocial}</TableCell>
                                            <TableCell>{item.cuit}</TableCell>
                                            <TableCell>{item.mail}</TableCell>
                                            <TableCell><Button onClick={() => eliminarOferente(item)}><DeleteOutlineOutlined style={{ color: 'red' }} /></Button></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        )

                        }
                    </Grid>
                </Grid>
            </DialogContent>
            <Grid container style={{ padding: '25px' }}>
                <Grid item xs={12}>
                    <Grid
                        container
                        spacing={1}
                        direction="row"
                        justify="center"
                        alignItems="center"
                    >
                        <Button
                            color="inherit"
                            variant="contained"
                            onClick={() => {
                                dispatch(props.closeModalHandler);
                                setOferentes([]);
                                dispatch(desSeleccionaOferente())
                            }}
                        >
                            Cerrar
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            style={{ marginLeft: '1rem' }}
                            onClick={() => handleSave()}
                        >
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    )
} 